<!-- =========================================================================================
    File Name: Invoice.vue
    Description: Invoice Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="invoice-page">
    <div class="container p-2">
      <vx-card v-if="dadosProposta">
        <!-- INVOICE METADATA -->
        <div class="vx-row leading-loose p-base">
          <div
            class="
              vx-col
              w-full
              sm:w-1/1
              md:w-1/2
              lg:w-1/2
              xl:w-1/2
              mt-base
              sm:text-center
            "
          >
            <img
              style="max-width: 250px"
              :src="dadosProposta.dadosAssociacao.logo"
              :alt="dadosProposta.dadosAssociacao.nome"
            />
          </div>
          <div
            class="
              vx-col
              w-full
              sm:w-1/1
              md:w-1/2
              lg:w-1/2
              xl:w-1/2
              md:text-right
            "
          >
            <h1 class="mt-5">{{ $t('Proposta') }}</h1>
            <div class="invoice__invoice-detail mt-6">
              <h6>{{ $t('Número:') }}</h6>
              <p>{{ dadosProposta.idProposta }}</p>

              <h6 class="mt-4">{{ $t('Data da Proposta') }}</h6>
              <p>{{ formataData(dadosProposta.createdAt) }}</p>
              <h6 v-if="dadosProposta.idStatus == 1" class="mt-4">
                {{ $t('Validade da Proposta') }}
              </h6>
              <p v-if="dadosProposta.idStatus == 1">
                <span
                  :class="
                    `con-vs-chip ${
                      propostaVencida != true 
                        ? 'bg-success' 
                        : this.aprovarPropostasVencidas 
                        ? 'bg-warning' : 'bg-danger'  
                    } text-white`
                  "
                  style="display: inline-block; float: none; padding-left: 10px"
                  >{{ getUltimoDia(dadosProposta.createdAt) }}</span
                >
              </p>
            </div>
          </div>
          <div class="vx-col w-full sm:w-1/1 md:w-1/2 lg:w-1/2 xl:w-1/2 mt-12">
            <h5 style="text-transform: uppercase">
              {{ dadosProposta.dadosCliente.associado }}
            </h5>
            <div class="invoice__recipient-info my-4">
              <p>
                <b>{{dadosProposta.somenteImplemento ? $t('Implemento:') :  $t('Veículo:') }}</b>
                {{ dadosProposta.dadosVeiculo.veiculoMarca }} -
                {{ dadosProposta.dadosVeiculo.veiculoModelo }}
                {{ dadosProposta.dadosVeiculo.anoFabricacao }} /
                {{ dadosProposta.dadosVeiculo.anoModelo }}
              </p>
              <br v-if="dadosProposta.implemento && dadosProposta.implementos.length > 0"/>
              <p >
                <ul>
                  <li v-for="(implemento, index) in dadosProposta.implementos" :key="index">
                    <p><b>{{ $t('Implemento:') }}</b>{{`${implemento.implementoMarca}  ${implemento.implementoModelo}`}}</p>
                    <p>
                      - {{implemento.placa ? `${$t('Placa Implemento:')} ${implemento.placa }` : implemento.placaVeiculoTrator ? `${$t('Placa veículo trator:')} ${implemento.placaVeiculoTrator}` : `` }} 
                      {{implemento.chassi && !implemento.placa ? `${$t('Chassi Implemento:')} ${implemento.chassi }` : implemento.chassiVeiculoTrator  && !implemento.placaVeiculoTrator  ? `${$t('Chassi veículo trator:')} ${implemento.chassiVeiculoTrator}` : `` }}
                    </p>
                    <p> - {{ $t('Valor Cobertura:')}} R$ {{implemento.valorCobertura}}</p>
                  </li>
                </ul>
              </p>
              <br v-if="dadosProposta.implemento && dadosProposta.implementos.length > 0"/>
              <p v-if="dadosProposta.agregado && dadosProposta.agregados.length > 0">
                <ul>
                  <li v-for="(agregado, index) in dadosProposta.agregados" :key="index">
                    <p><b>{{ $t('Agregado:') }}</b>{{`${agregado.descricaoAgregado} ${agregado.agregadoModelo}`}}</p>
                    <p>
                      {{agregado.placaVinculo ? `- ${$t('Placa de vínculo:')} ${agregado.placaVinculo }` : agregado.chassiVinculo ? ` - ${$t('Chassi de vinculo:')} ${agregado.chassiVinculo}` : `` }}
                    </p>
                    <p> - {{ $t('Valor Cobertura:')}} R$ {{agregado.valorCobertura}}</p>
                  </li>
                </ul>
              </p>
              <br v-if="dadosProposta.implemento && dadosProposta.implementos.length > 0"/>
                <p>
                <b>{{ $t('Grupo:') }}</b>
                {{ dadosProposta.somenteImplemento ? $t('Implementos') : dadosProposta.nomeGrupo }}
                </p>
                <p v-if="!dadosProposta.isZero && dadosProposta.dadosVeiculo.placa">
                <b>{{ dadosProposta.caminhao ? $t('Placa do veículo trator:') : $t('Placa:') }}</b>
                {{ dadosProposta.dadosVeiculo.placa }}
                </p>
                <p v-else>
                <b>{{ $t('Chassi:') }}</b>
                {{ dadosProposta.dadosVeiculo.chassi.toUpperCase() }}
                </p>
                <p>
                <b>{{ $t('Valor Fipe:') }}</b>
                {{ dadosProposta.dadosVeiculo.valorFipe | currency }}
                </p>
                <p v-if="dadosProposta.dadosVeiculo.codTipoVeiculo === 3 && dadosProposta.valorTotalConjunto">
                <b>{{ $t('Valor do conjunto:') }}</b>
                {{ dadosProposta.valorTotalConjunto | currency }}
                </p>
                <p>
                <b>{{ $t('Valor Cobertura:') }}</b>
                {{ dadosProposta.dadosVeiculo.valorCobertura | currency }}
                </p>
              </div>
              <div class="invoice__recipient-contact">
                <p
                class="flex items-center"
                v-if="dadosProposta.dadosCliente.email"
                >
                <feather-icon
                  icon="MailIcon"
                  svgClasses="h-4 w-4"
                ></feather-icon>
                <span class="ml-2">{{ dadosProposta.dadosCliente.email }}</span>
                </p>
                <p
                class="flex items-center"
                v-if="dadosProposta.dadosCliente.celular"
                >
                <feather-icon
                  icon="PhoneIcon"
                  svgClasses="h-4 w-4"
                ></feather-icon>
                <span class="ml-2">{{ dadosProposta.dadosCliente.celular }}</span>
                </p>
              </div>
              </div>
              <div
              class="
                vx-col
                w-full
                sm:w-1/1
                md:w-1/2
                lg:w-1/2
                xl:w-1/2
                mt-base
                md:text-right
                mt-12
              "
              >
              <h5 style="text-transform: uppercase">
                {{ dadosProposta.dadosAssociacao.nome }}
              </h5>
              <div class="invoice__company-info my-4">
                <p>{{ dadosProposta.regional }}</p>
              </div>
              <div class="invoice__company-contact">
                <p class="flex items-center md:justify-end">
                <feather-icon
                  icon="UserIcon"
                  svgClasses="h-4 w-4"
                ></feather-icon>
                <span class="ml-2">{{ $t('Consultor:') }} {{ dadosProposta.dadosVendedor.usuario }}</span>
                </p>
                <p class="flex items-center md:justify-end">
                <feather-icon
                  icon="MailIcon"
                  svgClasses="h-4 w-4"
                ></feather-icon>
                <span class="ml-2">{{ dadosProposta.dadosVendedor.usuarioEmail }}</span>
                </p>
                <p class="flex items-center md:justify-end">
                <feather-icon
                  icon="PhoneIcon"
                  svgClasses="h-4 w-4"
                ></feather-icon>
                <span class="ml-2">{{ dadosProposta.dadosVendedor.telefone }}</span>
                </p>
              </div>
              </div>
            </div>

            <!-- INVOICE CONTENT -->
            <div class="vx-row">
              <div class="p-base w-full sm:w-1/1 md:w-1/2 lg:w-1/2 xl:w-1/2">
              <!-- INVOICE TASKS TABLE -->
              <vs-table hoverFlat stripe :data="filtraBeneficios(3)">
                <!-- HEADER -->
                <template slot="thead">
                <vs-th style="width: 20px"></vs-th>
                <vs-th>{{ $t('COBERTURA') }}</vs-th>
                </template>

                <!-- DATA -->
                <template slot-scope="{ data }">
                <vs-tr v-for="(tr, index) in data" :key="index">
                  <vs-td>
                  <feather-icon
                    class="text-success"
                    icon="CheckIcon"
                    svgClasses="h-4 w-4"
                  ></feather-icon>
                  </vs-td>
                  <vs-td :data="data[index].nome">
                  {{ data[index].nome }}
                  <p v-if="data[index].descricao">
                    <small>{{ data[index].descricao }}</small>
                  </p>
                  </vs-td>
                </vs-tr>
                <vs-tr v-if="dadosProposta.exibirParticipacaoProposta">
                  <vs-td>
                  <feather-icon
                    class="text-success"
                    icon="MoneyIcon"
                    svgClasses="h-4 w-4"
                  ></feather-icon>
                  </vs-td>
                  <vs-td>
                  <b>{{ $t('Taxa') }} {{ $t('de') }} {{ $t('Evento') }}:</b>
                  <span
                    v-if="
                    dadosProposta.valorComplementoParticipacao &&
                      dadosProposta.valorComplementoParticipacao > 0
                    "
                    >{{
                    dadosProposta.valorComplementoParticipacao | currency
                    }}
                    +</span
                  >
                  {{ dadosProposta.valorCotaParticipacao }}% {{ $t('da') }} FIPE, {{ $t('mínimo') }}
                  {{ $t('de') }} {{ dadosProposta.valorParticipacaoMinimo | currency }}
                  </vs-td>
                </vs-tr>
                </template>
              </vs-table>

              <vs-table hoverFlat class="mt-2" stripe :data="filtraBeneficios(1)">
                <!-- HEADER -->
                <template slot="thead">
                <vs-th style="width: 20px"></vs-th>
                <vs-th>{{ $t('ASSISTÊNCIA') }}</vs-th>
                </template>

                <!-- DATA -->
                <template slot-scope="{ data }">
                <vs-tr v-for="(tr, index) in data" :key="index">
                  <vs-td>
                  <feather-icon
                    class="text-success"
                    icon="CheckIcon"
                    svgClasses="h-4 w-4"
                  ></feather-icon>
                  </vs-td>
                  <vs-td :data="data[index].nome">
                  {{ data[index].nome }}
                  <p v-if="data[index].descricao">
                    <small>{{ data[index].descricao }}</small>
                  </p>
                  </vs-td>
                </vs-tr>
                </template>
              </vs-table>

              <vs-table hoverFlat class="mt-2" stripe :data="filtraBeneficios(2)">
                <!-- HEADER -->
                <template slot="thead">
                <vs-th style="width: 20px"></vs-th>
                <vs-th>{{ $t('BENEFÍCIOS') }}</vs-th>
                </template>

                <!-- DATA -->
                <template slot-scope="{ data }">
                <vs-tr v-for="(tr, index) in data" :key="index">
                  <vs-td>
                  <feather-icon
                    class="text-success"
                    icon="CheckIcon"
                    svgClasses="h-4 w-4"
                  ></feather-icon>
                  </vs-td>
                  <vs-td :data="data[index].nome">
                  {{ data[index].nome }}
                  <p v-if="data[index].descricao">
                    <small>{{ data[index].descricao }}</small>
                  </p>
                  </vs-td>
                </vs-tr>
                </template>
              </vs-table>
          </div>

            <div class="p-base w-full sm:w-1/1 md:w-1/2 lg:w-1/2 xl:w-1/2">
            <!-- INVOICE TASKS TABLE -->
            <vs-table hoverFlat stripe :data="filtraProdutos(true)">
              <!-- HEADER -->
              <template slot="thead">
              <vs-th>{{ $t('PRODUTOS') }}</vs-th>
              </template>

              <!-- DATA -->
              <template slot-scope="{ data }">
              <vs-tr
                v-for="(tr, index) in data"
                :key="index"
                v-show="tr.produtoVisivel">
                <vs-td :data="tr.nomeProduto" :style="tr.excluido ? 'text-decoration: line-through' : ''">{{
                tr.nomeProduto
                }}</vs-td>
              </vs-tr>
              </template>
            </vs-table>

            <vs-table 
              class="mt-4"
              hoverFlat
              stripe
              :data="opcionais"
              noDataText="Nenhum Opcional Selecionado"
            >
              <!-- HEADER -->
              <template slot="thead">
              <vs-th>{{ $t('OPCIONAIS') }}</vs-th>
              </template>

              <!-- DATA -->
              <template  slot-scope="{ data }">
                <vs-tr
                v-for="(tr, index) in data"
                :key="index"
                >
                <vs-td :data="tr.nomeProduto">
                <vs-row>
                  <vs-col 
                  vs-type="flex"
                  vs-w="2"
                  vs-sm="2"
                  vs-xs="12">
                    <vs-switch :disabled="
                !((propostaVencida == false || aprovarPropostasVencidas) &&
                dadosProposta.idStatus == 1 &&
                isInterno == false)
              "
                    color="success"
                    v-model="tr.selecionado"
                    style="width: 60px"
                    @input="marcaDesmarcaOpcional(tr)"
                    >
                    <span slot="on">{{ $t('Sim') }}</span>
                    <span slot="off">{{ $t('Não') }}</span>
                    </vs-switch>
                  </vs-col>
                  <vs-col vs-type="flex"
                    vs-w="10"
                    vs-sm="10"
                    vs-xs="12"> {{tr.nomeProduto}} - {{ $t('Valor') }} {{ tr.valorFinal | currency }}
                  </vs-col>
                </vs-row>
                </vs-td>
              </vs-tr>
              </template>
             </vs-table>
            
             

            <!-- INVOICE SUMMARY TABLE -->
            <div
              class="vx-col w-full ml-auto mt-5"
              v-if="filtraProdutosMensais(true).length > 0"
            >
              <h5 class="text-center mt-3">{{ $t('Valores') }} {{ $t('médios') }} {{ $t('Mensais') }}</h5>
              <vs-table hoverFlat class="mt-4" noDataText>
              <vs-tr>
                <vs-th>{{ $t('SUBTOTAL') }}</vs-th>
                <vs-td>{{
                somaValorSubTotalMes(dadosProposta.produtos) >= somaValorTotalMes(dadosProposta.produtos) 
                  ? somaValorSubTotalMes(dadosProposta.produtos) 
                  : somaValorTotalMes(dadosProposta.produtos)| currency
                }}</vs-td>
              </vs-tr>
              <vs-tr>
                <vs-th>{{ $t('DESCONTOS') }}</vs-th>
                <vs-td>
                {{ calcDescontoMensal() < 0 ? 0 : calcDescontoMensal() | currency }}
                </vs-td>
              </vs-tr>
              <vs-tr>
                <th>{{ $t('TOTAL') }}</th>
                <td class="text-success text-bold">
                {{ somaValorTotalMes(dadosProposta.produtos) | currency }}
                </td>
              </vs-tr>
              </vs-table>
            </div>

            <div class="vx-row">
              <div class="vx-col w-full ml-auto mt-5">
              <H5 class="text-center mt-3">{{ $t('Valores') }} {{ $t('à') }} {{ $t('vista') }}</H5>
              <vs-table
                hoverFlat
                stripe
                class="mt-4"
                :data="filtraProdutosMensais(false)"
              >
                <!-- HEADER -->
                <template slot="thead">
                <vs-th>{{ $t('PRODUTO') }}</vs-th>
                <vs-th>{{ $t('VALOR') }}</vs-th>
                <vs-th>{{ $t('VALOR') }} {{ $t('FINAL') }}</vs-th>
                </template>

                <!-- DATA -->
                <template slot-scope="{ data }">
                <vs-tr v-for="(tr, index) in data" :key="index" v-show="data[index].produtoVisivel">
                  <vs-td class="w-1/3" :data="data[index].nomeProduto">{{
                  data[index].nomeProduto
                  }}</vs-td>
                  <vs-td class="w-1/3" :data="data[index].nomeProduto">{{
                  data[index].valor | currency
                  }}</vs-td>
                  <vs-td class="w-1/3" :data="data[index].nomeProduto">{{
                  data[index].valorFinal | currency
                  }}</vs-td>
                </vs-tr>
                </template>
              </vs-table>
              <vs-table hoverFlat class="mt-4" noDataText>
                <vs-tr>
                <vs-th>{{ $t('SUBTOTAL') }}</vs-th>
                <vs-td>{{
                  somaValorSubTotal(dadosProposta.produtos) | currency
                }}</vs-td>
                </vs-tr>
                <vs-tr>
                <vs-th>{{ $t('DESCONTOS') }}</vs-th>
                <vs-td>{{
                  (somaValorSubTotal(dadosProposta.produtos) -
                  somaValorTotal(dadosProposta.produtos))
                  | currency
                }}</vs-td>
                </vs-tr>
                <vs-tr>
                <th>{{ $t('TOTAL') }}</th>
                <td class="text-success">
                  {{ somaValorTotal(dadosProposta.produtos) | currency }}
                </td>
                </vs-tr>
              </vs-table>

              <div
                v-if="
                (propostaVencida == false || aprovarPropostasVencidas) &&
                  dadosProposta.idStatus == 1 &&
                  isInterno == false
                "
              >
                <h5 class="text-center mt-3 mb-6">{{ $t('Cupom') }} {{ $t('de') }} {{ $t('desconto') }}</h5>

                <vs-card>
                <vs-alert
                  v-if="dadosProposta.cupom"
                  color="success"
                  active="true"
                  class="mt-1 mb-3"
                  style="height: auto !important"
                >
                  {{ $t('O') }} {{ $t('cupom') }} {{ dadosProposta.cupom }} {{ $t('foi') }} {{ $t('aplicado') }}!
                </vs-alert>

                <div>
                  <vs-input
                  size="large"
                  class="w-full"
                  name="cupom"
                  id="input-cupom"
                  placeholder="Código do cupom"
                  autocomplete="off"
                  v-model="cupomDesconto"
                  @keyup="mascaraCupom($event)"
                  :danger="dangerCupomDesconto"
                  danger-text="Informe o cupom"
                  />
                </div>
                <div class="mt-3">
                  <vs-button
                  color="dark"
                  type="gradient"
                  class="w-full"
                  @click="applyDesconto()"
                  >
                  {{ $t('Aplicar') }} {{ $t('desconto') }}
                  </vs-button>
                </div>
                </vs-card>
              </div>
              </div>

              <vs-button
              v-if="
                (propostaVencida == false || aprovarPropostasVencidas) &&
                dadosProposta.idStatus == 1 &&
                isInterno == false
              "
              class="mt-5 w-full"
              color="success"
              type="gradient"
              icon-pack="feather"
              icon="icon-check"
              icon-before
              size="large"
              @click="popupActive = true"
              >{{ $t('CONTRATAR') }}</vs-button
              >
              <div v-if="dadosProposta.assinatura" class="text-center">
              <div class="vs-row">
                <div v-if="dadosProposta.assinatura" class="mt-3 mb-6 vx-col w-full ml-auto mt-5">
                <div class="con-checkbox" style="padding: 5px;">
                  <vs-checkbox val="automatically" v-model="dadosProposta.assinatura" disabled>
                  <span style="">{{ $t('Declaro') }} {{ $t('que') }} {{ $t('estou') }} {{ $t('ciente') }} {{ $t('de') }} {{ $t('todos') }} {{ $t('os') }} {{ $t('termos') }} {{ $t('que') }} {{ $t('aceitei') }} {{ $t('digitalmente') }}, {{ $t('ao') }} {{ $t('longo') }} {{ $t('desta') }} {{ $t('proposta') }}.</span>
                  </vs-checkbox>
                </div>
                </div>
              </div>
              <img :src="dadosProposta.assinatura" width="250"  style="margin: 0 auto;"/>
              <div class="vs-row">
                <div v-if="dadosProposta.assinatura" class="text-center mt-3 mb-6 vx-col w-full ml-auto mt-5">
                <hr class="" />
                {{dadosProposta.dadosCliente.associado}}
                </div>
              </div>
              </div>
            </div>
            </div>
        </div>

        <!-- INVOICE FOOTER
        <div class="invoice__footer text-right p-base">
          <p
            class="mb-4"
          >Transfer the amounts to the business amount below. Please include invoice number on your check.</p>
          <p>
            <span class="mr-8">
              BANK:
              <span class="font-semibold">FTSBUS33</span>
            </span>
            <span>
              IBAN:
              <span class="font-semibold">G882-1111-2222-3333</span>
            </span>
          </p>
        </div>-->
      </vx-card>
      <vs-popup
        class="holamundo"
        title="Confirmação de Contratação"
        :active.sync="popupActive"
      >
        <div v-if="confirmarDados == false">
          <p>
        {{ $t('Ao') }} {{ $t('clicar') }} {{ $t('em') }} "{{ $t('Confirmar') }}", {{ $t('você') }} {{ $t('será') }} {{ $t('direcionado') }} {{ $t('para') }} {{ $t('o') }} {{ $t('nosso') }} {{ $t('APP') }},
        {{ $t('onde') }} {{ $t('poderá') }} {{ $t('completar') }} {{ $t('os') }} {{ $t('seus') }} {{ $t('dados') }} {{ $t('e') }} {{ $t('fazer') }} {{ $t('a') }} {{ $t('vistoria') }}.
          </p>
          <h4 class="my-4">{{ $t('Fique') }} {{ $t('atento') }} {{ $t('aos') }} {{ $t('seguintes') }} {{ $t('pontos') }}:</h4>
          <ul>
        <li>
          1- {{ $t('Para') }} {{ $t('acessar') }}, {{ $t('informe') }} {{ $t('seu') }} {{ $t('CPF/CNPJ') }} {{ $t('e') }} {{ $t('a') }} {{ $t('placa') }} {{ $t('do') }} {{ $t('seu') }} {{ $t('veículo') }}
        </li>
        <li>2- {{ $t('Depois') }} {{ $t('de') }} {{ $t('logado') }}, {{ $t('você') }} {{ $t('deve') }} {{ $t('clicar') }} {{ $t('em') }} {{ $t('Cotações') }}</li>
        <li>
          3- {{ $t('Você') }} {{ $t('irá') }} {{ $t('visualizar') }} {{ $t('essa') }} {{ $t('proposta') }} {{ $t('que') }} {{ $t('acabou') }} {{ $t('de') }} {{ $t('dar') }} {{ $t('o') }} {{ $t('aceite') }}
          ({{ $t('protocolo') }} {{ dadosProposta.idProposta }}), {{ $t('clique') }} {{ $t('em') }} "{{ $t('Realizar') }} {{ $t('Vistoria') }}"
        </li>
          </ul>
          <p class="my-4">{{ $t('Algumas') }} {{ $t('instruções') }} {{ $t('para') }} {{ $t('tirar') }} {{ $t('as') }} {{ $t('fotos') }}:</p>
          <ol style="list-style-type: inherit; margin-left: 15px">
        <li>
          {{ $t('Escolha') }} {{ $t('um') }} {{ $t('local') }} {{ $t('bem') }} {{ $t('iluminado') }}, {{ $t('de') }} {{ $t('preferência') }} {{ $t('de') }} {{ $t('dia') }}, {{ $t('em') }} {{ $t('local') }}
          {{ $t('aberto') }}
        </li>
        <li>{{ $t('Sempre') }} {{ $t('tire') }} {{ $t('fotos') }} {{ $t('com') }} {{ $t('a') }} {{ $t('visão') }} {{ $t('nítida') }} {{ $t('da') }} {{ $t('placa') }} {{ $t('do') }} {{ $t('veículo') }}</li>
        <li>{{ $t('Vidros') }} {{ $t('e') }} {{ $t('portas') }} {{ $t('devem') }} {{ $t('estar') }} {{ $t('fechados') }}</li>
        <li>
          {{ $t('Se') }} {{ $t('você') }} {{ $t('não') }} {{ $t('possui') }} {{ $t('tanto') }} {{ $t('domínio') }} {{ $t('e/ou') }} {{ $t('manuseio') }} {{ $t('no') }} {{ $t('celular') }}, {{ $t('peça') }} {{ $t('um') }}
          {{ $t('amigo') }} {{ $t('ou') }} {{ $t('parente') }} {{ $t('para') }} {{ $t('te') }} {{ $t('ajudar') }}. {{ $t('Lembrando') }} {{ $t('que') }} {{ $t('só') }} {{ $t('você') }} {{ $t('pode') }}
          {{ $t('assinar') }} {{ $t('e') }} {{ $t('sair') }} {{ $t('na') }} {{ $t('selfie') }}.
        </li>
          </ol>
          <vs-button
        class="mt-5 w-full"
        color="primary"
        type="gradient"
        icon-pack="feather"
        icon="icon-check"
        icon-before
        size="large"
        @click="confirmarDados = true"
        >{{ $t('ENTENDI') }}</vs-button
          >
        </div>
        <div v-else>
          <vs-alert
            color="warning"
            title="Atenção!!"
            active="true"
            class="my-3 mb-10"
            style="height: auto !important"
            >{{ $t('Esse') }} {{ $t('passo') }} {{ $t('é') }} {{ $t('muito') }} {{ $t('importante') }}, {{ $t('para') }} {{ $t('continuar') }} {{ $t('confirme') }} {{ $t('seus') }} {{ $t('dados') }}!
          </vs-alert>
          <form role="form">

          <div class="vx-col container-radio"> 
            <vs-radio
              v-for="item in tiposDePessoa"
              :key="item.idTipoPessoa"
              v-model="tipoDePessoa"
              vs-name="btnRadioTipoPessoa"
              :vs-value="item.idTipoPessoa"
              class="w-full mb-3"
            >
              {{ item.tipoPessoa }}
            </vs-radio>
          </div>

            <vs-input
              v-if="tipoDePessoa === 1"
              class="w-full no-icon-border mb-10"
              name="CPF/CNPJ"
              id="CPF"
              autocomplete="off"
              aria-autocomplete="none"
              role="presentation"
              label-placeholder="CPF"
              v-model="formConfirmacao.cpfcnpj"
              v-validate="{ required: true, min: 14 }"
              :state="validateState('CPF')"
              :danger="validateClass('CPF')"
              val-icon-danger="clear"
              danger-text="Preencha este Campo"
              v-mask="'###.###.###-##'"
              icon-pack="feather"
              icon="icon-user-check"
              icon-no-border
              :disabled="!isCpfCanChange()"
            />
            <vs-input
              v-else
              class="w-full no-icon-border mb-10"
              name="CNPJ"
              id="CNPJ"
              autocomplete="off"
              aria-autocomplete="none"
              role="presentation"
              label-placeholder="CNPJ"
              v-model="formConfirmacao.cpfcnpj"
              v-validate="{ required: true, min: 18 }"
              :state="validateState('CNPJ')"
              :danger="validateClass('CNPJ')"
              val-icon-danger="clear"
              danger-text="Preencha este Campo"
              v-mask="'##.###.###/####-##'"
              icon-pack="feather"
              icon="icon-briefcase"
              :disabled="!isCpfCanChange()"
              icon-no-border
            />

            <vs-input
              name="email"
              icon="icon icon-mail"
              icon-pack="feather"
              label-placeholder="Email"
              v-model="formConfirmacao.email"
              class="w-full no-icon-border mb-10"
              v-validate="{ required: true, email: true }"
              :state="validateState('email')"
              :class="validateClass('email')"
            />

            <vs-input
              class="w-full no-icon-border mb-10"
              name="Celular"
              id="Celular"
              label-placeholder="Celular"
              v-model="formConfirmacao.celular"
              v-validate="{ required: true, min: 15 }"
              :state="validateState('Celular')"
              :danger="validateClass('Celular')"
              val-icon-danger="clear"
              danger-text="Preencha este Campo"
              v-mask="'(##) #####-####'"
              icon-pack="feather"
              icon="icon-smartphone"
              icon-no-border
            />

          </form>

          <vs-button
            v-if="!CPFdeOutroAssociado"
            class="mt-5 w-full"
            color="success"
            type="gradient"
            icon-pack="feather"
            icon="icon-check"
            icon-before
            size="large"
            @click="contratar()"
            >{{ $t('CONFIRMAR') }}</vs-button
          >
          
          <div style="margin-bottom: 250px"></div>
        </div>
      </vs-popup>
    </div>
  </div>
</template>

<script>
//#region Import's

import moment from "moment";
import notify from "./../../utils/notify";
import service from "../../services";
import cpfCnpj from "../../services/cpfCnpj";
import locale from "./../../locale";

export default {
  name: 'invoiceEmpresas',
  data() {
    return {
      aprovarPropostasVencidas: null,
      dadosProposta: null,
      propostaVencida: false,
      isInterno: true,
      popupActive: false,
      confirmarDados: false,
      tipoDePessoa : null,
      tiposDePessoa: [
        {idTipoPessoa: 1, tipoPessoa: 'Pessoa Física'}, 
        {idTipoPessoa: 2, tipoPessoa: 'Pessoa Jurídica'}
      ], 
      formConfirmacao: {
        cpfcnpj: null,
        celular: null,
        email: null
      },
      cpfDuplicado: false,
      CPFdeOutroAssociado: false,
      arrayDuplicados: [],
      cupomDesconto: null,
      dangerCupomDesconto: false,
      opcionais:[],
      produtosRemovidos: [],
    };
  },
  computed: {},
  methods: {
    marcaDesmarcaOpcional(obj){
      const _produtosAtualizar = [];
      const _produtos = this.dadosProposta.jsonFacilitadorProdutos

      let acao = ''
      if(obj.selecionado==true){
        acao = 'adicionar'
      }else{
        acao = 'remover'
      }
      
      let idProdutosSobrepor = [];
      let _produtoSobrepostos = [];

      if(obj.sobreporOutrosProdutos){
        idProdutosSobrepor = obj.sobreporOutrosProdutos.split(',')

        _produtoSobrepostos = this.dadosProposta.produtos.filter(item => {
          let _produto = null;

          idProdutosSobrepor.forEach(id => {
            if(id == item.id_produto){
              _produto = item;
            }
          });

          return _produto
        });

        if(_produtoSobrepostos.length == 0){
          _produtoSobrepostos = _produtos.filter(item => {
            let _produto = null;

          idProdutosSobrepor.forEach(id => {
            if(id == item.id_produto){
              _produto = item;
            }
          });

          return _produto
          })
        }

      }

      if(acao === 'adicionar'){
        _produtoSobrepostos.forEach(item =>{
            _produtosAtualizar.push({
              ...item,
              idProduto: item.id_produto,
              acao: 'remover',
              idProposta: this.dadosProposta.idProposta
            })
          });
      }else{
        _produtoSobrepostos.forEach(item =>{
          if(!obj.selecionado){
            this.opcionais.forEach(itemOp =>{
              if(itemOp.id_produto == item.idProduto){
                itemOp.selecionado = false;
              }
            })
          }


          if(item.obrigatorio){
            _produtosAtualizar.push({
              ...item,
              idProduto: item.id_produto,
              acao: 'adicionar',
              idProposta: this.dadosProposta.idProposta
            })
          }
            
          });
      }

      const objSend = {};
      objSend.idProposta = this.dadosProposta.idProposta;
      objSend.acao = acao
      objSend.idProduto = obj.idProduto
      objSend.valorFinal = obj.valorFinal
      objSend.idProposta = this.dadosProposta.idProposta;
      objSend.idEmpresa = this.dadosProposta.idEmpresa;

      _produtosAtualizar.push(objSend);

      const dados = [acao, this.dadosProposta.idProposta, _produtosAtualizar]

      this.$vs.loading();
          service
            .post("CotacaoAberta", "alteraOpcionalInvoice1", dados)
            .then(res => {
              this.$vs.loading.close();
              this.buscaDados()
            })
            .catch(e=>{
              this.$vs.loading.close();
              obj.selecionado = !obj.selecionado
              this.$vs.notify({
                position: "top-center",
                title: "Atenção",
                text: `Não foi possível Atualizar opcionais`,
                color: "danger"
              });
            })

    },
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    validateClass(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return this.veeErrors.has(ref);
      }
      return null;
    },
    confirmaCpfOutroAssociado() {
      this.formConfirmacao.unificarAssociado = true;
      this.formConfirmacao.idSelecionadoMescla = undefined;
      this.contratar();
    },
    selecionarItemDuplicado(item) {
      this.formConfirmacao.idSelecionadoMescla = item.id_prospect;

      this.arrayDuplicados.forEach(element => {
        element.selecionado = false;
      });
      item.selecionado = true;
    },
    contratar() {
      var objSend = { ...this.formConfirmacao };
      objSend.idCotacao = this.dadosProposta.idProposta;
      // o dia de vencimento é definido posterior;
      objSend.diaVencimentoMensalidade = null;
      objSend.idEmpresa = this.dadosProposta.idEmpresa;

      if (
        this.cpfDuplicado == true &&
        !this.formConfirmacao.idSelecionadoMescla
      ) {
        this.$vs.notify({
          position: "top-center",
          title: "Atenção",
          text: `Selecione o Registro Prioritário, clicando no icone de estrela`,
          color: "danger"
        });

        return;
      }

      if (cpfCnpj.valida_cpf_cnpj(this.formConfirmacao.cpfcnpj) == false) {
        this.$vs.notify({
          position: "top-center",
          title: "Atenção",
          text: `Este CPF/CNPJ não é válido`,
          color: "danger"
        });

        return;
      }

      this.$validator.validateAll().then(result => {
        if (result) {
          this.$vs.loading();
          service
            .post("CotacaoAberta", "aceiteProposta", objSend)
            .then(res => {
              let linkRelativo = window.location.origin;
              linkRelativo = linkRelativo
                .replace('adm.', 'app.')
                .replace('8081', '8080');
              this.$vs.loading.close();
              if (res.data.sucess == true) {
                
                var link = `${linkRelativo}/?idEmpresa=${
                  this.dadosProposta.idEmpresa
                }&cpfcnpj=${this.formConfirmacao.cpfcnpj.replace(
                  '/',
                  '',
                )}&placa=${this.dadosProposta.dadosVeiculo.placa}`;
                if (res.data.token) {
                  //localStorage.setItem('user-token', res.data.token);
                  link = `${linkRelativo}/?idEmpresa=${this.dadosProposta.idEmpresa}&token=${res.data.token}&chave=${this.dadosProposta.chave}`;
                }
                this.linkRedirect = link;
                window.location = link
              } 
            })
            .catch(() => {
              this.$vs.notify({
                position: "top-center",
                title: "Atenção",
                text: "Não foi possível confirmar a Contratação",
                color: "danger"
              });
              this.$vs.loading.close();
            });
        }
      });
    },
    filtraProdutos(obrigatorios) {
      if (obrigatorios == true)
        return this.dadosProposta.produtos.filter(x => x.obrigatorio == true);
      else
        return this.dadosProposta.produtos.filter(x => x.obrigatorio != true);
    },
    filtraProdutosMensais(mensal) {
      if (mensal == true)
        return this.dadosProposta.produtos.filter(x => x.isMensal == true);
      else return this.dadosProposta.produtos.filter(x => x.isMensal != true);
    },
    filtraProdutosOpcionaisFacilitador(){
      return this.dadosProposta.jsonFacilitadorProdutos.filter(x => x.obrigatorio == false);
    },
    getUltimoDia(data) {
      var date = new Date(data);
      var ultimoDia = new Date(date.getFullYear(), date.getMonth() + 1, 0);
      if (moment(ultimoDia).diff(moment(), "days") < 0) {
        this.propostaVencida = true;
      }

      if(this.propostaVencida && this.aprovarPropostasVencidas) {
        return moment().add(7, "days").format("DD/MM/YYYY");
      }

      return (
        `${moment(ultimoDia).format("DD/MM/YYYY")} | ${moment(ultimoDia).diff(moment(), "days")} dias`
          .replace("-", "")
      );
    },
    filtraBeneficios(tipo) {
      var aux = this.dadosProposta.beneficios.filter(x => x.tipo == tipo);
      return aux;
    },
    formataData(data) {
      return moment(data).format("DD/MM/YYYY HH:mm");
    },
    formataDataUTC(data) {
      return moment(data)
        .utc()
        .format("DD/MM/YYYY HH:mm");
    },
    somaValorTotal(produtos) {
      var total = 0;
      produtos.forEach(element => {
        if (element.isMensal != true) total = total + element.valorFinal;
      });
      return total;
    },
    somaValorTotalMes(produtos) {
      var total = 0;
      produtos.forEach(element => {
        if (element.isMensal == true) total = total + element.valorFinal
      });
      return total;
    },
    somaValorSubTotal(produtos) {
      var total = 0;
      produtos.forEach(element => {
        if (element.isMensal != true) total = total + element.valor;
      });
      return total;
    },
    somaValorSubTotalMes(produtos) {
      var total = 0;
      produtos.forEach(element => {
        if (element.valor > 0)
          if (element.isMensal == true) total = total + element.valor;
      });
      
      return total;
    },
    somaValorDescontoMes(produtos) {
      var total = 0;
      produtos.forEach(element => {
        if (element.isMensal == true) total = total + element.descontoConcedido;
      });
      return total;
    },
    calcDescontoMensal(){
      const produtos = this.dadosProposta.produtos;
      const desconto = 
        this.somaValorSubTotalMes(produtos) - this.somaValorTotalMes(produtos);

      return desconto;
    },
    somaValorDesconto(produtos) {
      var total = 0;
      produtos.forEach(element => {
        if (element.isMensal != true) total = total + element.descontoConcedido;
      });
      return total;
    },
    buscaDados() {
      if (this.$route.query.interno) {
        this.isInterno = true;
      } else {
        this.isInterno = false;
      }
      this.$vs.loading();
      var objSend = {};
      objSend.chave = this.$route.params.chave;

      service
        .post("CotacaoAberta", "buscaDados", objSend)
        .then(res => {
          this.dadosProposta = res.data[0];
          this.formConfirmacao.email = this.dadosProposta.dadosCliente.email;
          this.formConfirmacao.celular = this.dadosProposta.dadosCliente.celular;
          this.formConfirmacao.cpfcnpj = this.dadosProposta.dadosCliente.cpf;
          this.aprovarPropostasVencidas = this.dadosProposta.dadosAssociacao.aprovarPropostasVencidas;
          this.opcionais = []
          if(this.dadosProposta.jsonFacilitadorProdutos && this.dadosProposta.jsonFacilitadorProdutos != "0"){
            this.dadosProposta.jsonFacilitadorProdutos = JSON.parse(this.dadosProposta.jsonFacilitadorProdutos)
            if(this.dadosProposta.jsonFacilitadorProdutos){
              this.dadosProposta.jsonFacilitadorProdutos.forEach(element => {
              if(element.obrigatorio!=true && element.produtoVisivel){
                element.selecionado = false;

                var aux = this.dadosProposta.produtos.find(
                  x=>x.id_produto==element.id_produto
                );

                if(aux){
                  element.selecionado = true
                }
                this.opcionais.push({
                  idProduto:element.id_produto,
                  selecionado: element.selecionado,
                  nomeProduto: element.nomeProduto,
                  valorFinal : element.valorFinal,
                  visivelProposta: element.produtoVisivel,
                  sobreporOutrosProdutos: element.sobreporOutrosProdutos
                })
              }
            });
            }
            
          }else{
            this.dadosProposta.produtos.forEach(element => {
              if(element.obrigatorio!=true){
                this.opcionais.push({
                  idProduto:element.id_produto,
                  selecionado: true,
                  nomeProduto: element.nomeProduto,
                  valorFinal : element.valorFinal
                })
              }
            });
          }

          this.marcaProdutosCarregamento();

          const {tipo:tipoPessoaProposta} = this.dadosProposta.dadosCliente;

          this.tipoDePessoa = tipoPessoaProposta === "Pessoa Física" 
            ? 1 
            : tipoPessoaProposta === "Pessoa Juríca" 
            ? 2 
            : 1;

          this.$vs.loading.close();
        })
        .catch(e => {
          this.$vs.notify({
            position: "top-center",
            title: "Atenção",
            text: e,
            color: "danger"
          });
          this.$vs.loading.close();
        });
    },
    mascaraCupom(event) {
      const input = event.target;
      input.value = input.value.replace(new RegExp(" ", "g"), "-");
      this.dangerCupomDesconto = false;
    },
    async applyDesconto() {
      try {
        this.dangerCupomDesconto = false;

        if (!this.cupomDesconto) {
          this.dangerCupomDesconto = true;
          notify.notifyFail(this.$vs, "Informe o cupom!");
          return;
        }

        if (this.dadosProposta.cupom == this.cupomDesconto.toUpperCase()) {
          this.dangerCupomDesconto = true;
          notify.notifyFail(this.$vs, "Este cupom já foi uitlizado!");
          return;
        }

        this.$vs.loading();

        const payload = {
          cupom: this.cupomDesconto.toUpperCase(),
          idProposta: this.dadosProposta.idProposta,
          idEmpresa: this.dadosProposta.idEmpresa
        };

        await service.post("Campanha", "aplicarCupom", payload);
        this.cupomDesconto = "";

        this.buscaDados();
      } catch (error) {
        notify.notifyFail(this.$vs, error);
      } finally {
        this.$vs.loading.close();
      }
    },
    marcaProdutosCarregamento() {
      this.opcionais.forEach((item) => {
        if (item.selecionado) {
          const prodssobreporOutrosProdutos = item.sobreporOutrosProdutos.split(',');
          prodssobreporOutrosProdutos.forEach((element) => {
            this.dadosProposta.produtos.forEach((elementSel, index) => {
              if (elementSel.id_produto == element) {
                if (item.selecionado == true) {
                  this.produtosRemovidos.push(elementSel);
                  elementSel.excluido = true;
                  // this.dadosProposta.produtos.splice(index, 1);
                } else {
                  this.produtosRemovidos.splice(index, 1);
                  elementSel.excluido = false;
                }
              }
            });
          });
        }
      });
    },
    isCpfCanChange() {
      let retorno = true;
      if ( this.dadosProposta.dadosCliente.situacao ||  this.dadosProposta.dadosCliente.idStatus) {
        retorno = false;
      }

      return retorno;
    },
  },
  mounted() {
    this.buscaDados();
  },
  created() {
    this.$validator.localize("ptBr", locale);
  },
  components: {}
};
</script>

<style>
#input-cupom {
  text-transform: uppercase;
}

.container-radio{
  display: flex;
}

.linha-assinatura{
  max-width: 200px;
}
</style>
